var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ecm__wishlist section__padding"},[_c('div',{staticClass:"ecm__wishlist-container"},[(!_vm.activeSkeleton)?_c('Books',{attrs:{"books":_vm.wishlist}}):_c('BooksSkeleton')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }